import React, { FunctionComponent, useState, useEffect } from 'react'
import { useSelector } from "react-redux"
import { ContainerBlock, ModalContent, ModalHeader, ModalTitle } from './styled.components'
import { getParamsSegmentation } from 'actions/segmentacion'
import ListsGroup from 'Components/ListsGroup'

type FormSegmentacionProps = {
    item: any
    action: string
    errors: any
    handleOnChange: (e: any) => void
}

const FormSegmentacion: FunctionComponent<FormSegmentacionProps> = ({ item, action, errors, handleOnChange }) => {

    const [params, setParams] = useState([])

    const { catalogs } = useSelector((state: any) => state.theme)
    const { context } = useSelector((state: any) => state.theme)

    useEffect(() => {
        handleCallParams()
    }, [])

    const handleCallParams = () => {
        getParamsSegmentation(item.idUsuario, item.idVista).then((res) => {
            if (res) {
                res = res.filter((param: any) => (param.idTipoParametro === 2 || param.idTipoParametro === 3) && param.visible)
                setParams(res)
                handleOnChange(params)
            }
        })
    }

    const handleParseParams = (list: any) => {
        let helper: any = {};
        let idsParams: any = list.reduce((prevItem: any, currentItem: any) => {
            let key = `${currentItem.idParametro}-${currentItem.codigoParametro}-${currentItem.nombreParametro}-${currentItem.idTipoParametro}-${currentItem.tipoParametro}-${currentItem.codigoParametroAnt}-${currentItem.codigoParametroSig}`
            if (!helper[key]) {
                helper[key] = Object.assign({}, currentItem)
                prevItem.push(helper[key])
            }
            return prevItem;
        }, []).map((item: any) => {
            return {
                idParametro: item.idParametro,
                codigoParametro: item.codigoParametro,
                nombreParametro: item.nombreParametro,
                idTipoParametro: item.idTipoParametro,
                tipoParametro: item.tipoParametro,
                codigoParametroAnt: item.codigoParametroAnt,
                codigoParametroSig: item.codigoParametroSig,
                segmentacionValores: list.filter((value: any) => value.idParametro === item.idParametro).map((value: any) => {
                    return {
                        idValor: value.idValor,
                        valorDescripcion: value.valorDescripcion,
                        idValorAnt: value.idValorAnt,
                        segmentado: value.segmentado,
                        descSegmentacion: value.descSegmentacion,
                        codigoParametro: value.codigoParametro,
                        codigoParametroAnt: value.codigoParametroAnt,
                    }
                })
            }
        })
        return idsParams
    }

    const handleOnCheckAll = (e: any) => {
        let newParams: any = [...params]
        params.forEach((param: any, indexParam: number) => {
            if (param.codigoParametro === e.codigoParametro) {
                let segmentado = (e.allChecked) ? 0 : 1
                if (param.codigoParametroAnt) {
                    let paramAnt = params.find((paramTemp: any) => paramTemp.codigoParametro === param.codigoParametroAnt && paramTemp.idValor === param.idValorAnt)
                    //@ts-ignore
                    if (paramAnt && paramAnt?.segmentado === 1) {
                        newParams[indexParam].segmentado = segmentado
                    }
                } else {
                    newParams[indexParam].segmentado = segmentado
                }
                if (segmentado === 0) {
                    newParams = Validatechilds({ ...param, segmentado: 0 }, newParams)
                }
            }
        })
        setParams(newParams)
        handleOnChange(params)
    }

    const handleOnCheckChange = (e: any) => {
        let newParams: any = [...params]
        params.forEach((param: any, indexParam: number) => {
            if (param.codigoParametro === e.codigoParametro && param.idValor === e.idValor && param.idValorAnt === e.idValorAnt) {
                let segmentado = (e.segmentado) ? 0 : 1
                newParams[indexParam].segmentado = segmentado
                if (segmentado === 0) {
                    newParams = Validatechilds({ ...param, segmentado: 0 }, newParams)
                }
            }
        })
        setParams(newParams)
        handleOnChange(params)
    }

    const Validatechilds = (parent: any, paramsTemp: any) => {
        let newParams: any = [...paramsTemp]
        if (parent.codigoParametroSig) {
            paramsTemp.filter((param: any) => param.codigoParametro === parent.codigoParametroSig && param.idValorAnt === parent.idValor).forEach((param: any, indexParam: number) => {
                if (param.segmentado === 1) {
                    paramsTemp.forEach((value: any, indexValue: number) => {
                        if (value.codigoParametro === param.codigoParametro && value.idValor === param.idValor && value.idValorAnt === param.idValorAnt) {
                            newParams[indexValue].segmentado = 0
                        }
                    })
                    newParams = Validatechilds({ ...param, segmentado: 0 }, newParams)
                }
            })
        }
        return newParams
    }

    return (
        <ContainerBlock bg={catalogs.backgroundItem}>
            <ModalHeader>
                <ModalTitle textColor={context.textColor}>{`Segmentación de Datos - ${item.reportName}`}</ModalTitle>
            </ModalHeader>
            <ModalContent>
                {(params.length > 0) ? (
                    <ListsGroup params={handleParseParams(params)} handleOnCheckAll={handleOnCheckAll} handleOnCheckChange={handleOnCheckChange}></ListsGroup>
                ) : (
                    <>No hay parametros de segmentacion</>
                )}
            </ModalContent>

        </ContainerBlock>
    )
}

export default FormSegmentacion